const ABFieldNumberCore = require("../../core/dataFields/ABFieldNumberCore");
module.exports = class ABFieldNumber extends ABFieldNumberCore {};
